<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  import banner from "@/components/commoncoms/banner";
  export default {
    name: "join",
    components:{
      banner
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/join.vue